// Lote 112 (Robson, 24/10/2026) — subtipos do "Compromisso" (Reunião, Perícia, Lembrete, outros digitados)
// viram a ETIQUETA do evento em todo o app, cada um com a sua cor; a Agenda filtra por eles.
// O valor interno do tipo continua "reuniao" e o subtipo continua em hearing.meeting_subject (sem migração).
export const normTxt = (t) => String(t || "").normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();

const FIXOS = { reuniao: "Reunião", pericia: "Perícia", lembrete: "Lembrete" };

/** { key: "reuniao"|"pericia"|"lembrete"|"outros", label } — ou null quando o campo "Tipo" está vazio ("Compromisso"). */
export function subtipoCompromisso(hearing) {
  const raw = String(hearing?.meeting_subject || "").trim();
  if (!raw) return null;
  const k = normTxt(raw);
  if (FIXOS[k]) return { key: k, label: FIXOS[k] };
  return { key: "outros", label: raw.length > 22 ? `${raw.slice(0, 21)}…` : raw.charAt(0).toUpperCase() + raw.slice(1) };
}

// Cores da etiqueta (classes completas para o Tailwind enxergar).
export const SUBTIPO_COR = {
  reuniao: "bg-blue-100 text-blue-700 border border-blue-200",
  pericia: "bg-violet-100 text-violet-800 border border-violet-200",
  lembrete: "bg-teal-100 text-teal-800 border border-teal-200",
  outros: "bg-slate-100 text-slate-700 border border-slate-300",
  compromisso: "bg-blue-100 text-blue-700 border border-blue-200",
};

export const SUB_FILTROS = [
  { key: "todos", label: "Todos" },
  { key: "reuniao", label: "Reunião" },
  { key: "pericia", label: "Perícia" },
  { key: "lembrete", label: "Lembrete" },
  { key: "outros", label: "Outros" },
];

/** Chave do filtro de um compromisso: reuniao | pericia | lembrete | outros (inclui "sem tipo"). */
export const subFiltroKey = (hearing) => subtipoCompromisso(hearing)?.key || "outros";
